export default "__VITE_ASSET__CTgXm$9i__"